// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1Wvly","colCheckbox":"styles_colCheckbox__WoHLk"};